
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91group_45key_938EeCdwqP_lVMQvHVAJf15zBN33cCCyrEFXnpl7SVjD8Meta } from "/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/files/groups/[group-key].vue?macro=true";
import { default as callbackYgX34PHkk_sc97RLuXvw4kYBpIqoqSKOPLL5QabZwi8Meta } from "/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/callback.vue?macro=true";
import { default as errorVPj7r0sa2yzYvQpe9TVm4UWcBbeS1Ycohcd0yAGy6QAMeta } from "/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/error.vue?macro=true";
import { default as login80gJef8Fue8Z5kfKv6z_Nox_8pxcf1iJOE563rcPOg4Meta } from "/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/login.vue?macro=true";
import { default as logoutlI2yknlwVOKrN_yTwdmdFZwLXNtYG2PYQt_H_hyS0YgMeta } from "/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/logout.vue?macro=true";
import { default as indexp2f_5tj_wPG2tIKOrf0cKrCAueuuQM0xTs4pEW9nzpkMeta } from "/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/index.vue?macro=true";
export default [
  {
    name: "file-group-detail",
    path: "/files/groups/:groupkey()",
    meta: _91group_45key_938EeCdwqP_lVMQvHVAJf15zBN33cCCyrEFXnpl7SVjD8Meta || {},
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/files/groups/[group-key].vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: callbackYgX34PHkk_sc97RLuXvw4kYBpIqoqSKOPLL5QabZwi8Meta || {},
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/callback.vue")
  },
  {
    name: "auth-error",
    path: "/auth/error",
    meta: errorVPj7r0sa2yzYvQpe9TVm4UWcBbeS1Ycohcd0yAGy6QAMeta || {},
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/error.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: login80gJef8Fue8Z5kfKv6z_Nox_8pxcf1iJOE563rcPOg4Meta || {},
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/login.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: logoutlI2yknlwVOKrN_yTwdmdFZwLXNtYG2PYQt_H_hyS0YgMeta || {},
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/auth/logout.vue")
  },
  {
    name: "files-detail",
    path: "/files/detail",
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/files/detail/index.vue")
  },
  {
    name: "files",
    path: "/files",
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/files/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/settings/index.vue")
  },
  {
    name: "upload",
    path: "/upload",
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/upload.vue")
  },
  {
    name: "workflow-runs",
    path: "/workflow-runs",
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/workflow-runs/index.vue")
  },
  {
    name: "index",
    path: "/",
    redirect: indexp2f_5tj_wPG2tIKOrf0cKrCAueuuQM0xTs4pEW9nzpkMeta?.redirect,
    component: () => import("/home/runner/work/fc-datastore/fc-datastore/client-v3/src/pages/index.vue")
  }
]